import { ReactNode, FC } from 'react'
import Icon from './Icon'

interface Props {
  items: { title: string; content: string | ReactNode }[]
}

const Accordion: FC<Props> = ({ items }) => {
  return (
    <ul className="Accordion">
      {items.map(({ title, content }, i) => {
        const id = 'details-' + title.replace(/[^a-zA-Z]/g, '')
        return (
          <li
            key={title}
            className="Accordion-item"
            data-toggle="container"
            data-toggle-type="accordion"
          >
            <button
              className="Accordion-titleContainer px-6"
              aria-controls={id}
              aria-expanded="false"
              data-toggle="trigger"
            >
              <h6 className="Accordion-title">{title}</h6>
              <Icon
                variant="caret-down"
                className="Accordion-icon Icon Icon--xs"
              />
            </button>

            <div
              className="Accordion-content display-none"
              id={id}
              aria-hidden="true"
              data-toggle="content"
            >
              {content}
            </div>
          </li>
        )
      })}
    </ul>
  )
}

export default Accordion
